import React, { ChangeEvent, useEffect, useState } from "react";
import {
  TextFieldProps,
  TextField,
  makeStyles,
  Box,
  FormHelperText,
} from "@material-ui/core";

export interface SATextFieldProps {
  hasWhiteFields?: boolean;
  requiredError?: string | undefined;
  showCharacterCount?: boolean;
  characterLimit?: number;
  afterReset?: boolean;
  dynamicCharCount?: number;
  onBlur?: (event: any) => any;
}

const useStyles = makeStyles((theme: any) => ({
  whiteTextField: {
    background: theme.palette.common.white,
  },
}));

export const SATextField = (props: TextFieldProps & SATextFieldProps) => {
  const classes = useStyles();

  const [characterCount, setCharacterCount] = useState<number>(0);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange && props.onChange(event);
    props.showCharacterCount && setCharacterCount(event.target.value.length);
  };
  useEffect(() => {
    setCharacterCount(0);
  }, [props.afterReset]);
  useEffect(() => {
    typeof(props.dynamicCharCount) !== "undefined" && props.dynamicCharCount !== null &&setCharacterCount(props.dynamicCharCount);
    
  }, [props.dynamicCharCount]);

  useEffect(() => {
    setCharacterCount(0);
  }, [props.showCharacterCount]);

  return (
    <>
      <TextField
        {...props}
        label={props.label}
        id={props.id}
        name={props.name}
        className={props.className}
        type="text"
        variant="outlined"
        fullWidth
        inputRef={props.inputRef}
        InputLabelProps={props.InputLabelProps}
        inputProps={{
          ...props.inputProps,
          maxLength: props.characterLimit,
          ...{ className: classes.whiteTextField },
        }}
        error={props.error}
        helperText={props.helperText}
        autoComplete={props.autoComplete || "none"}
        onChange={onChange}
        onBlur={props.onBlur}
      />
      {props.showCharacterCount && (
        <Box
          position="relative"
          top={props.helperText ? "-20px" : "0px"}
          display="flex"
          justifyContent="flex-end"
        >
          <FormHelperText
            error={props.error}
          >{`${characterCount} / ${props.characterLimit}`}</FormHelperText>
        </Box>
      )}
    </>
  );
};
